import { MdWarning } from 'react-icons/md';
import {
  FullScreenOverlay,
  Icon,
  IconContainer,
} from '@nbirl/nbi-common-ui-libs';

import { useFolderTree } from '../context';
import { CreateFolder } from './create-folder.component';

export const NoFolders = () => {
  const { refetch, canCreateMainFolder } = useFolderTree();

  return (
    <>
      <FullScreenOverlay>
        <div className="flex flex-col items-center space-y-2 h-max">
          <IconContainer variant="light">
            <Icon icon={<MdWarning className="text-primary-500" />} />
          </IconContainer>
          <p className="text-2xl font-medium text-gray-700">
            You don’t have access to any folders yet.
          </p>
          <p>Please contact your administrator.</p>
        </div>
      </FullScreenOverlay>

      {canCreateMainFolder && (
        <div className="fixed bottom-0 w-80 p-2">
          <CreateFolder
            onSuccess={refetch}
            modalHeading="New Main Folder"
            text="Create main folder"
            className="w-full"
          />
        </div>
      )}
    </>
  );
};
